


<div class="parent">


    <div class="center">
        <label>Enter password to access the application</label>
        <form>
            <input #password placeholder="Password">
         </form>
         <button mat-raised-button color="primary" (click)="onSubmit(password.value)">Submit</button>
    </div>
  
  
  </div>
  
 